import React, { Component } from 'react';

import 'element-theme-default';

import '../../index.css';
import { BrowserRouter as Router, Route, HashRouter } from 'react-router-dom';
import Login from '../../components/Login/Login';

import '../../firebase';
import firebase from 'firebase';

import { connect } from 'react-redux';
import { setUser, setRooms } from '../../store/actionCreators';

import Dashboard from '../Dashboard/Dashboard';
import Spinner from '../Spinner/Spinner';
import { getRooms } from '../../services/rooms';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      isLoggedIn: false,
      selectedNav: '1',
      loading: true,
    };

    this.handlers = mapDispatchToProps(this.props.dispatch);
    this.onSelect = this.onSelect.bind(this);
  }

  componentWillMount() {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        this.handlers.handleUserChange(user.email);
        await this.getData(); 
        this.setState({ isLoggedIn: true, loading: false });     
      } else {
        this.setState({ isLoggedIn: false, loading: false });
      }
    });
  }

  async getData() {
    try {
      const { data } = await getRooms();
      this.handlers.handleRoomsChange(data.data);
      console.log('handle: ', data);
    } catch (err) {
      console.error(err);
    }
  }

  onSelect(val) {
    this.setState({ selectedNav: val });
  }

  render() {
    const isLoggedIn = this.state.isLoggedIn;
    const loading = this.state.loading;

    return loading 
      ? <Spinner />
      : isLoggedIn
        ? <Dashboard />
        : <Login />
  }
}

const mapDispatchToProps = dispatch => ({
  handleUserChange(event) {
    dispatch(setUser(event));
  },
  handleRoomsChange(event) {
    dispatch(setRooms(event))
  },
});

export default connect(mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js